<div data-qa-id="editor-body" class="editor-body">
  <div data-qa-id="editor-body-loadingState" v-if="isAiResponseLoading" class="loading-overlay">
    <MdIconLoader size="xl" animation="spin-right" duration="1s" color="blue-duck--500" />
  </div>

  <div data-qa-id="editor-content-wrapper" v-if="!isDiffView" class="editor-content-wrapper">
    <div class="editor-scroll-content">
      <EditorContent :editor="editor" />
    </div>
  </div>

  <div data-qa-id="editor-body-diffView" v-else class="diff-container">
    <div class="diff-view">
      <div data-qa-id="editor-body-diffView-originalPane" class="pane original-pane">
        <MdTypography data-qa-id="editor-body-diffView-originalPane-title" color="spirits--600"
          variant="micro1--medium">
          {{ $t('pages.aiTextEditor.original_text') }}
        </MdTypography>
        <div data-qa-id="editor-body-diffView-originalPane-contentWrapper" class="pane-content-wrapper">
          <EditorContent class="pane-content" :editor="diffEditor" />
        </div>
      </div>
      <div data-qa-id="editor-body-diffView-suggestedPane" class="pane suggested-pane">
        <div data-qa-id="editor-body-diffView-suggestedPane-header" class="pane-header">
          <MdTypography data-qa-id="editor-body-diffView-suggestedPane-header-title" color="spirits--600"
            variant="micro1--medium">
            {{ $t('pages.aiTextEditor.ai_suggested_text') }}
          </MdTypography>
          <div data-qa-id="editor-body-diffView-suggestedPane-feedbackButtons" v-if="!feedbackGiven" class="feedback-buttons">
            <ThumbsUp data-qa-id="suggestedPane-feedbackButtons-like" v-tooltip="{content: $t('pages.aiTextEditor.feedback_tooltip'), placement: 'top', triggers: ['click','hover']}" @click="updateFeedbackFunction('liked')" />
            <ThumbsDown data-qa-id="suggestedPane-feedbackButtons-dislike" v-tooltip="{content: $t('pages.aiTextEditor.feedback_tooltip'), placement: 'top', triggers: ['click','hover']}" @click="updateFeedbackFunction('disliked')" rotate="down" />
          </div>
          <div v-else-if="feedbackGiven === 'liked'">
            <ThumbsUp data-qa-id="suggestedPane-feedbackStatus" fill="#1a73e8"/>
          </div>
          <div v-else-if="feedbackGiven === 'disliked'">
            <ThumbsDown data-qa-id="suggestedPane-feedbackStatus" fill="#dc0024"/>
          </div>
        </div>
        <div data-qa-id="editor-body-diffView-suggestedPane-contentWrapper" class="pane-content-wrapper">
          <div data-qa-id="editor-body-diffView-suggestedPane-content" class="pane-content" v-html="aiSuggestedText">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>